import { createAsyncThunk } from '@reduxjs/toolkit';
import { postApi } from 'redux/apis';
import { IOneOffConfigurations } from 'redux/slice/oneOffSlice';

// Get One-Off Expense Allocation Data
export const getOneOffExpenseAllocationAction = createAsyncThunk(
    'oneOff/getAllocation',
    async (
        params: {
            fromDate: string;
            toDate: string;
            oneOffConfigurations: IOneOffConfigurations;
            page?: number;
            limit?: number;
        },
        { rejectWithValue }
    ) => {
        try {
            const companyId = localStorage.getItem('companyId');
            const payload = {
                companyId,
                fromDate: params.fromDate,
                toDate: params.toDate,
                oneOffConfigurations: params.oneOffConfigurations,
                page: params.page || 1,
                limit: params.limit || 20,
            };
            const response = await postApi('/expense-journal/one-off-expense-allocation', payload);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Preview One-Off Expense Journal Entries
export const previewOneOffExpenseJournalEntriesAction = createAsyncThunk(
	'oneOff/previewEntries',
	async (
		params: {
			fromDate?: string;
			toDate?: string;
			oneOffConfigurations?: IOneOffConfigurations;
			journalId?: string;
			page?: number;
			limit?: number;
			isSingleAccountAllocation?: boolean;
			configAccount?: { name: string; value: string } | null

			isSummarizedJournalView?: boolean;
		},
		{ rejectWithValue }
	) => {
		try {
			const companyId = localStorage.getItem('companyId');
			const payload: any = {
				companyId,
			};

			// If journalId is provided, only send companyId and journalId
			if (params.journalId) {
				payload.journalId = params.journalId;
				// Include isSummarizedView when journalId is provided
				if (params.isSummarizedJournalView !== undefined) {
					payload.isSummarizedJournalView = params.isSummarizedJournalView;
				}
			} else {
				// New preview requires fromDate, toDate, and oneOffConfigurations
				if (
					!params.fromDate ||
					!params.toDate ||
					!params.oneOffConfigurations
				) {
					return rejectWithValue({
						message:
							'fromDate, toDate, and oneOffConfigurations are required for new preview',
					});
				}
				payload.fromDate = params.fromDate;
				payload.toDate = params.toDate;
				payload.oneOffConfigurations = params.oneOffConfigurations;
				payload.page = params.page || 1;
				payload.limit = params.limit || 10;

				// Optional fields for account replacement
				if (params.isSingleAccountAllocation !== undefined) {
					payload.isSingleAccountAllocation = params.isSingleAccountAllocation;
				}
				if (params.configAccount) {
					payload.configAccount = params.configAccount;
				}
				// Include isSummarizedView for new preview
				if (params.isSummarizedJournalView !== undefined) {
					payload.isSummarizedJournalView = params.isSummarizedJournalView;
				}
			}

			const response = await postApi(
				'/expense-journal/one-off-preview-entries',
				payload
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

